import { render } from "./MnemonicWordInput.vue?vue&type=template&id=6dc8876c&scoped=true"
import script from "./MnemonicWordInput.vue?vue&type=script&lang=js"
export * from "./MnemonicWordInput.vue?vue&type=script&lang=js"

import "./MnemonicWordInput.vue?vue&type=style&index=0&id=6dc8876c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc8876c"]])

export default __exports__